'use client';

import React, { useEffect } from 'react';
import { useAuth, useUser } from '@clerk/clerk-react';
import useUserStore from '@/lib/hooks/zustand-stores/use-user-store';
import { getCurrentUserObjId } from '@/lib/utils'
import { useLogger } from '@/lib/hooks/useLogger';
const UserInitializer: React.FC = () => {
  const saveSessionToDb = useUserStore(state => state.saveSessionToDb);
  const updateClerkUnsafeUserMetadata = useUserStore(state => state.updateClerkUnsafeUserMetadata);
  const saveSubscriptionDataToClerk = useUserStore(state => state.saveSubscriptionDataToClerk);
  const initializeSecondaryData = useUserStore(state => state.initializeSecondaryData)
  const { user: clerkUser } = useUser();
  const mixusUser = useUserStore(state => state.user)

  const logger = useLogger();
  useEffect(() => {
    const extendUser = async () => {
      if (mixusUser?._id) {
        initializeSecondaryData()
      }
    }
    extendUser()
  }, [mixusUser?._id]);

  // 2. Update Clerk's unsafe metadata when the user is loaded in the store
  useEffect(() => {
    if (clerkUser && mixusUser?._id && !clerkUser.unsafeMetadata?._id) {
      const updateMetadata = async () => {
        try {
          await updateClerkUnsafeUserMetadata(clerkUser, mixusUser);
        } catch (error) {
        }
      };
      updateMetadata();
    }
  }, [clerkUser, mixusUser?._id]);


  // 3. Save subscription data to Clerk when the user is loaded in the store
  // useEffect(() => {
  //   if (mixusUser?.subscriptionDetails && mixusUser.clerkUserId && clerkUser) {
  //     const updateSubscriptionData = async () => {
  //       try {
  //         await saveSubscriptionDataToClerk(mixusUser.clerkUserId, mixusUser);
  //       } catch (error) {
  //       }
  //     };
  //     updateSubscriptionData();
  //   }
  // }, [clerkUser?.id, mixusUser?.subscriptionDetails, mixusUser?.clerkUserId]);

  // 4. Save session to the database when the user is loaded, and it's not localhost
  useEffect(() => {
    if (mixusUser?._id && clerkUser && process.env.NEXT_PUBLIC_VERCEL_ENV && !process.env.NEXT_PUBLIC_VERCEL_ENV.includes('localhost')) {
      const saveSession = async () => {
        try {
          await saveSessionToDb(clerkUser, mixusUser._id);
          logger.info('Session saved to DB.');
        } catch (error) {
          logger.error('Failed to save session to DB:', error);
        }
      };
      saveSession();
    }
  }, [clerkUser, mixusUser?._id]);

  return null;
};

export default UserInitializer;
